import { TestimonialComponent } from "./testimonialComponent";

const DefaultTestimonialDisplay = (props) => {
    const { testimonialList = [] } = props;
    return (
        <div className="testimonial-default-items-wrapper">
            {testimonialList.map((testimonial, index) => {
                return <TestimonialComponent item={testimonial} key={index} />;
            })}
        </div>
    );
};

DefaultTestimonialDisplay.displayName = "DefaultTestimonialDisplay";
export { DefaultTestimonialDisplay };
